<template>
  <div>
    <swiper class="banner" :options="bannerSwiperOptions">
      <swiper-slide>
        <img @click="layerShow = true" src="/static/images/banner-product-1.png" >
      </swiper-slide>
      <swiper-slide>
        <img @click="layerShow = true" src="/static/images/banner-product-2.png" >
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div class="box bgf5">
      <div class="title">我们的产品优势</div>
      <div class="sub-title">打通各个环节，让物流行业从集业务发展、资源整合、结算管理等提供完整的一体化管理，使货主、司机企业的利益最大化</div>
      <div class="width1200 el-row--flex is-justify-space-between">
        <div class="card1">
          <img src="/static/images/icon/icon-product-advantage-1.png" >
          <div class="card1-title">平台系统</div>
          <div class="card1-sub-title">在全国各地广泛运营，独立品牌和私有化部署，打造属于你的私人平台</div>
        </div>
        <div class="card1">
          <img src="/static/images/icon/icon-product-advantage-2.png" >
          <div class="card1-title">运营支持</div>
          <div class="card1-sub-title">一对一专业指导，结合实际情况，答疑解惑，个性化服务</div>
        </div>
        <div class="card1">
          <img src="/static/images/icon/icon-product-advantage-3.png" >
          <div class="card1-title">增值服务</div>
          <div class="card1-sub-title">满足各种所需的增值服务，包括ETC发票、轨迹、油气等服务，覆盖物流全业务场景，提供全方位服务</div>
        </div>
        <div class="card1">
          <img src="/static/images/icon/icon-product-advantage-4.png" >
          <div class="card1-title">税务规划</div>
          <div class="card1-sub-title">面向成员平台，提供合规、低成本的税务解决方案</div>
        </div>
      </div>
    </div>
    <div class="box banner">
      <img class="product-img" src="/static/images/bg-product.png" >
      <div class="product-box width1200">
        <div class="title">为企业量身打造全渠道一站式服务平台</div>
        <div class="sub-title">打通各个环节，让物流一体化，从找找货到配送，提供完整的解决方案一体化的系统管理，司机通过小程序进行配送，简单易操作</div>
        <div class="product el-row--flex is-justify-center">
          <div class="product-menu">
            <el-menu :default-active="$route.path" class="el-menu-demo" router>
              <el-menu-item index="/product">
                <span slot="title">网络货运平台</span>
              </el-menu-item>
              <el-menu-item index="/product/etc">
                <span slot="title">ETC系统</span>
              </el-menu-item>
              <el-menu-item index="/product/tms">
                <span slot="title">TMS系统</span>
              </el-menu-item>
              <el-menu-item index="/product/wms">
                <span slot="title">WMS系统</span>
              </el-menu-item>
            </el-menu>
          </div>
          <div class="product-page">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="title">助力企业降本增效，获取数字化核心竞争力</div>
      <div class="sub-title">集成大数据平台化以及“互联网+”把全国物流的车货运力资源，集中整合。利用平台便捷性，采用线上操作，精准配置。合理为物流企业提高效率，降低成本</div>
      <div class="width1200 el-row--flex is-justify-space-between">
        <div class="card2">
          <img src="/static/images/icon/icon-core-1.png" >
          <div class="card2-title">高效整合货运资源</div>
          <div class="card2-sub-title">上游承接着海量货主、托运人，下游承接着有车承运人，成为上下游资源的整合者</div>
        </div>
        <div class="card2">
          <img src="/static/images/icon/icon-core-2.png" >
          <div class="card2-title">信息化能力</div>
          <div class="card2-sub-title">大幅度提升自身信息化管理能力打破信息，实现对业务流程的全过程动态管控</div>
        </div>
        <div class="card2">
          <img src="/static/images/icon/icon-core-3.png" >
          <div class="card2-title">数字化转型，快速盈利</div>
          <div class="card2-sub-title">促使企业物流向物流企业转型，以及企业数字化升级，通过对资源、平台的整合给企业带来新的利润增长点</div>
        </div>
        <div class="card2">
          <img src="/static/images/icon/icon-core-4.png" >
          <div class="card2-title">技术与数据监管</div>
          <div class="card2-sub-title">省级交通运输主管部门会对网络货运经营者的信息平台进行有效对接，实现数据的监测管理</div>
        </div>
      </div>
    </div>
    <div class="product-layer-box" v-if="layerShow">
      <div class="product-layer-mask" @click="layerShow = false"></div>
      <div class="product-layer">
        <div class="el-row--flex">
          <img src="/static/images/qrcode-product.png" >
          <div class="product-layer-content">
            <div class="el-row--flex is-justify-space-between">
              <div class="product-layer-title">商务联系</div>
              <div class="product-layer-close" @click="layerShow = false"></div>
            </div>
            <div class="product-layer-sec-title">获取免费网络货运解决方案</div>
            <div class="product-layer-sec-title">咨询等可以微信扫码添加项目经理</div>
            <div class="product-layer-sub-title">咨询热线</div>
            <div class="product-layer-phone">137-5711-6496</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import Swiper2, { Pagination, Autoplay } from 'vue-awesome-swiper'
  // Swiper2.use([Pagination, Autoplay])

  export default {
    data() {
      return {
        bannerSwiperOptions: {
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          }
        },
        layerShow: false
      }
    }
  }
</script>

<style lang="scss">
  .swiper-container {
    .swiper-slide {
      &-active { z-index: 2; }
    }

    .swiper-pagination-bullet {
      width: 24px;
      height: 6px;
      border-radius: 0;
      background-color: #66acff;
      opacity: 1;

      &.swiper-pagination-bullet-active {
        background-color: #fff;
      }
    }
  }

  .box {
    position: relative;
  }

  .title {
    font-size: 25px;
    color: #333;
  }

  .sub-title {
    width: 572px;
    font-size: 16px;
    color: #666;
  }

  .card1 {
    width: 273px;
    height: 278px;
    margin-top: -26px;
    margin-bottom: 47px;
    padding: 0 24px;
    background-color: #fff;
    box-sizing: border-box;

    img {
      width: 100px;
      height: 100px;
      margin: 24px auto;
    }

    &-title {
      font-size: 20px;
      color: #333;
    }

    &-sub-title {
      margin-top: 16px;
      font-size: 14px;
      color: #999;
    }
  }

  .product-box {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    z-index: 2;

    .title {
      color: #fff;
    }

    .sub-title {
      color: #e1e1e1;
    }

    .product { margin-top: -24px; }

    .product-menu {
      height: 572px;
      margin-right: 44px;
      padding-top: 65px;
      padding-right: 16px;
      border-right: 3px solid rgba($color: #8D98B6, $alpha: .5);
      box-sizing: border-box;

      .el-menu {
        background-color: transparent;

        .el-menu-item {
          width: 112px;
          height: 40px;
          padding: 0!important;
          line-height: 40px;

          & + .el-menu-item { margin-top: 16px; }

          &.is-active,
          &:hover {
            background-color: #1875f0;
            color: #fff;
          }

          span {
            font-size: 16px;
            color: #e1e1e1;
          }
        }
      }
    }

    .product-page {
      width: 742px;
    }
  }

  .card2 {
    width: 288px;
    text-align: left;

    &-title {
      margin-top: -35px;
      margin-left: 24px;
      font-size: 20px;
      color: #fff;
    }

    &-sub-title {
      margin: 15px auto 96px;
      font-size: 14px;
      color: #999;
    }
  }

  .product-layer-box {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 3;

    .product-layer-mask {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba($color: #000000, $alpha: .3);
    }

    .product-layer {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 550px;
      height: 250px;
      padding: 35px;
      background-color: #fff;
      box-sizing: border-box;

      &-content {
        width: calc(100% - 209px);
        margin-left: 28px;
        text-align: left;
      }

      &-title {
        font-size: 24px;
        color: #333;
      }

      &-close {
        width: 15px;
        height: 15px;
        background-image: url(/static/images/icon/icon-close.png);
      }

      &-sec-title {
        margin-top: 6px;
        font-size: 18px;
        color: #999;
      }

      &-sub-title {
        margin-top: 26px;
        font-size: 18px;
        color: #333;
      }

      &-phone {
        margin-top: 10px;
        font-size: 26px;
        font-weight: bold;
        color: #333;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/product.vue